import { useState } from 'react'
import Formsy from 'formsy-react'
import { initiateSignupFlow } from 'login-and-signup/actions'
import { languageSelector } from 'i18n/selectors'

import featureToggles from 'shared/featureToggles'
import { DOCUMENT_TYPES } from 'shared/components/DocumentDataFields/constants'
import { CUSTOMER_TYPE_BUSINESS, CUSTOMER_TYPE_INDIVIDUAL } from 'shared/constants'

import DefaultFlowForm from './DefaultFlowForm'
import SubscriptionLiteForm from './SubscriptionLiteForm'
import IndividualOrBusiness from './IndividualOrBusiness'

const SignupContainer = ({ initiateSignupFlow, active, handleFocus, language, signUpFormError }) => {
    const [canSubmit, setCanSubmit] = useState(false)
    const [acceptTerms, setAcceptTerms] = useState(false)

    const [customerType, setCustomerType] = useState(DOCUMENT_TYPES[0]?.value)

    const acceptTermsHandler = event => {
        setAcceptTerms(event.target.checked)
    }

    const enableSubmit = () => {
        setCanSubmit(true)
    }

    const disableSubmit = () => {
        setCanSubmit(false)
    }

    const submit = data => {
        const {
            firstName,
            lastName,
            email,
            password,
            news,
            offers,
            nif,
            documentNumber,
            documentType,
            businessName,
            phone,
        } = data

        initiateSignupFlow(
            firstName,
            lastName,
            email,
            password,
            !!news,
            !!offers,
            nif,
            featureToggles.additionalSignupData ? documentType || customerType : '',
            documentNumber,
            businessName,
            phone
        )
    }

    return (
        <div
            tabIndex="0"
            className={`header-signup-container ${active ? 'active' : ''}`}
            onFocus={handleFocus}
            role="form"
            aria-labelledby="signupFormTitle">
            <Formsy
                className="header-form signup-form"
                onSubmit={submit}
                onValid={enableSubmit}
                onInvalid={disableSubmit}>
                <fieldset>
                    {/* hidden "fake" input fields to disable autofill */}
                    <input type="email" name="email" className="d-none" aria-hidden="true" />
                    <input type="password" name="pasword" className="d-none" aria-hidden="true" />
                    {featureToggles.additionalSignupData && (
                        <input
                            type="text"
                            name="customerType"
                            value={customerType}
                            className="d-none"
                            aria-hidden="true"
                        />
                    )}
                    <legend>
                        <h2 id="signupFormTitle">
                            <T>auth.sign.up.title</T>
                        </h2>
                    </legend>
                    <IndividualOrBusiness customerType={customerType} setCustomerType={setCustomerType} />
                    {(!featureToggles.hasSubcriptionLite || customerType === CUSTOMER_TYPE_INDIVIDUAL) && (
                        <DefaultFlowForm
                            active={active}
                            canSubmit={canSubmit}
                            acceptTerms={acceptTerms}
                            acceptTermsHandler={acceptTermsHandler}
                            customerType={customerType}
                            signUpFormError={signUpFormError}
                        />
                    )}
                    {featureToggles.hasSubcriptionLite && customerType === CUSTOMER_TYPE_BUSINESS && (
                        <SubscriptionLiteForm language={language} />
                    )}
                </fieldset>
            </Formsy>
        </div>
    )
}

export default compose(
    connect(createStructuredSelector({ language: languageSelector }), {
        initiateSignupFlow,
    })
)(SignupContainer)
